import React from 'react';
import useSWR from 'swr';
import debug from 'debug';
import {Carousel, DescriptiveText, LoadingSpinner} from '../../../shared';
import Insight from '../../components/insights/Insight';
import {SizeMe} from 'react-sizeme';

const log = debug('circleblack:investor:Insights');

const Insights = () => {
  const {data: articles, error: articlesError} = useSWR('/documents/?type=Article');
  const totalVerticalPadding = 75;

  if (!articles) {
    if (articlesError) {
      return <DescriptiveText>{articlesError?.response?.data?.error?.msg || 'Failed to load data from API.'}</DescriptiveText>;
    }
    return <LoadingSpinner/>;
  }
  log('rendering');
  return <SizeMe monitorHeight={true}>
    {({size}) => <Carousel childMinWidth={'200px'} childMinHeight={'200px'} maxHeight={'100%'}>
      {articles.length === 1
        ? <Insight
          imgWidth={Math.floor(((size.height < size.width ? size.height - totalVerticalPadding : size.width * 0.65))) + 'px'}
          key={articles[0].id}
          article={articles[0]}
          fontSize={'12px'}
          margin={'0 0 100px 0'}
        />
        : articles.map(art => <Insight
          imgWidth={Math.floor(((size.height < size.width ? size.height * 0.65 : size.width * 0.7))) + 'px'}
          key={art.id}
          article={art}
          fontSize={'12px'}
        />)}
    </Carousel>}
  </SizeMe>;
};

export default Insights;

